import Title from './title'
import Description from './description'
import DetailBlock from './block-detail'
import AboutBlock from './block-about'

export default function Freedom() {
  const t = useI18n()

  return (
    <AboutBlock>
      <Title>{ t('page:joinUs.freedom.title') }</Title>
      <Description>{ t('page:joinUs.freedom.description1') }</Description>
      <div className='h-4'/>
      <div className='flex flex-col-reverse md:space-x-8 md:flex-row md:mt-8'>
        <div className='mt-[-12px] z-[1]'>
          <DetailBlock
            provide={ t('page:joinUs.freedom.description3') }
            detail={ t('page:joinUs.freedom.description4') }
            statistics={ [
              t('page:joinUs.freedom.description5', { dayoff: 9 })
            ] }/>
        </div>

        <C.Image
          className='aspect-[5/3] shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1)] ml-[-32px] md:ml-0 w-[100vw] md:w-3/4'
          src={ cdn('next/join-us/freedom-1.jpg') }
        />
      </div>

    </AboutBlock>
  )
}
